export default __webpack_public_path__ + "static/media/icon-tiny-close.99b8271a.svg";